// extracted by mini-css-extract-plugin
export var container_header = "FirstVideoCafetera-module--container_header--30e3f";
export var contianer_section = "FirstVideoCafetera-module--contianer_section--41225";
export var endText = "FirstVideoCafetera-module--endText--71f0d";
export var style1 = "FirstVideoCafetera-module--style1--a3800";
export var style2 = "FirstVideoCafetera-module--style2--11b27";
export var style3 = "FirstVideoCafetera-module--style3--babc4";
export var style4 = "FirstVideoCafetera-module--style4--556cc";
export var video = "FirstVideoCafetera-module--video--08899";
export var videoSource = "FirstVideoCafetera-module--videoSource--a6a51";